import React from 'react'

const Copyright = () => {
  return (
    <p style={{ padding: '24px' }}>
      © Copyright {new Date().getFullYear()}{' '}
      <a href="https://the-gw.com" target="_blank">
        <b>Gatway ICT</b>
      </a>
      , all rights reserved | V 1.1.1
    </p>
  )
}

export default Copyright
